<template>
  <div class="cr-flex cr-flex-col cr-w-100 gap-5 spc-pt-5 spc-pb-6 spc-mx-2">
    <BaseShimmer
      class="cr-align-self-start cr-br-large"
      height="48px"
      width="317px"
    />
    <BaseShimmer
      class="cr-align-self-end cr-br-large"
      height="176px"
      width="100%"
    />
    <BaseShimmer
      class="cr-align-self-start cr-br-large"
      height="64px"
      width="100%"
    />
    <BaseShimmer
      class="cr-align-self-end cr-br-large"
      height="225px"
      width="100%"
    />
  </div>
</template>

<script>
import BaseShimmer from './BaseShimmer.vue'

export default {
  name: 'CraftyCopilotChatMessageLoading',
  components: {
    BaseShimmer,
  },
}
</script>

<style lang="scss" scoped>
.base-shimmer.cr-br-large {
  &::after {
    border-radius: var(--cr-br-large);
  }
}
</style>
